"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccordionBlockTitleProperty = exports.accordionBlockTitlePropertyDefinition = void 0;
exports.accordionBlockTitlePropertyDefinition = {
    view: {
        label: 'Section Title',
        style: 'h3',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'accordion-block-title',
};
const isAccordionBlockTitleProperty = (prop) => {
    return prop.name === exports.accordionBlockTitlePropertyDefinition.name;
};
exports.isAccordionBlockTitleProperty = isAccordionBlockTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjb3JkaW9uLWJsb2NrLXRpdGxlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYWNjb3JkaW9uLWJsb2NrLXRpdGxlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGVBQWU7UUFDdEIsS0FBSyxFQUFFLElBQUk7S0FDWjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSx1QkFBdUI7Q0FDRSxDQUFBO0FBSTFCLE1BQU0sNkJBQTZCLEdBQUcsQ0FBQyxJQUFrQixFQUF1QyxFQUFFO0lBQ3ZHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw2Q0FBcUMsQ0FBQyxJQUFJLENBQUE7QUFDakUsQ0FBQyxDQUFBO0FBRlksUUFBQSw2QkFBNkIsaUNBRXpDIn0=